module.exports = __webpack_public_path__ + "img/illustration-step-3-02.b28287d9.svg";